"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Bookmark = function Bookmark(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/bookmark-bookmark" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "rectangle-bookmark" + unique,
    xlinkHref: "#path-1-bookmark" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-bookmark" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6,2 L18,2 C19.1045695,2 20,2.8954305 20,4 L20,21.190983 C20,21.4671254 19.7761424,21.690983 19.5,21.690983 C19.4223775,21.690983 19.3458209,21.6729105 19.2763932,21.6381966 L12,18 L4.7236068,21.6381966 C4.47661755,21.7616912 4.17628103,21.6615791 4.0527864,21.4145898 C4.01807255,21.3451621 4,21.2686056 4,21.190983 L4,4 C4,2.8954305 4.8954305,2 6,2 Z",
    fill: "inherit",
    id: "path-1-bookmark" + unique
  }))));
};

Bookmark.propTypes = propTypes;
var _default = Bookmark;
exports["default"] = _default;